import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './TierProductCard';
import { publishDraftTier } from '../../Tier/redux/creator/actions';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'onPublish'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  onPublish: params => dispatch(publishDraftTier(params)),
});

export default connect(mapStateToProps, mapDispatchToProps);
